import {RoutingConstants as rc} from './routing-constants';
import {PartialRouting} from './partial-routing';
import {RoutingDashboard} from './implementations/routing-dashboard';
import {RoutingRecoveryPassword} from './implementations/routing-recovery-password';
import {RoutingUsers} from './implementations/routing-users';
import {RoutingMovies} from './implementations/routing-movies';
import {RoutingAcl} from './implementations/routing-acl';

export class Routing {
  static mustActivate = new PartialRouting(rc.mustActivate);
  static notAuthorized = new PartialRouting(rc.notAuthorized);
  static dashboard = new RoutingDashboard(rc.dashboard);
  static movies = new RoutingMovies(rc.movies);
  static genres = new PartialRouting(rc.genres);
  static carousel = new PartialRouting(rc.carousel);
  static users= new RoutingUsers(rc.users);
  static acl= new RoutingAcl(rc.acl);
  static recoveryPassword = new RoutingRecoveryPassword(rc.recoverPassword);
}
